import { render } from "./AdmDashBoard.vue?vue&type=template&id=0e2d4cea&scoped=true"
import script from "./AdmDashBoard.vue?vue&type=script&lang=js"
export * from "./AdmDashBoard.vue?vue&type=script&lang=js"

import "./AdmDashBoard.vue?vue&type=style&index=0&id=0e2d4cea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2d4cea"]])

export default __exports__